import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import durationToStr from '@/libs/utils/durationToStr'
import Button from '@/shared/Button'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const mapStateToProps = ({ loading, campaign }) => ({
  isLoading: loading['campaign/getCourseProgramDetails'],
  data: campaign.previewCourse,
})

const CourseItem = ({ avgCourseRating, courseLength, coverImage, description, name }) => {
  const { t } = useTranslation()
  return (
    <Grid container item spacing={2}>
      <Grid item xs={4}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box sx={{ width: '100%' }} component="img" src={coverImage} />
          <Typography sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            {t('general.good_rating_count')}
            <ThumbUpAlt color="primary" sx={{ mx: 1 }} />
            {avgCourseRating || 0}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={8}>
        <Stack direction="row" mb={2}>
          <Typography>{name}</Typography>
          <Typography sx={{ ml: 3 }}>{`${t('general.course_duration')} ${durationToStr(
            courseLength,
          )}`}</Typography>
        </Stack>

        <Typography>{description}</Typography>

        <Typography>{t('course.notice')}</Typography>
      </Grid>
    </Grid>
  )
}

const CourseDialog = ({ courseId, title, dispatch, isLoading, data, ...props }) => {
  const { onClose } = props
  const { t } = useTranslation()

  useEffect(() => {
    if (courseId) {
      dispatch({ type: 'campaign/getCourseProgramDetails', payload: { courseId } })
    }
  }, [dispatch, courseId])

  return (
    <Dialog {...props} fullWidth maxWidth="md">
      <Paper
        elevation={2}
        sx={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          padding: 2,
          textAlign: 'center',
        }}
      >
        {title}
      </Paper>

      <DialogContent>
        <Grid container spacing={5}>
          {isLoading && (
            <Grid item display="flex" justifyContent="center" alignItems="center" xs={12} my={2}>
              <CircularProgress />
            </Grid>
          )}
          {!isLoading && data && data.map(d => <CourseItem key={d.templateId} {...d} />)}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="neutral" onClick={() => onClose()}>
          {t('general.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(mapStateToProps)(CourseDialog)
